import Currency from 'helpers/Currency';
import { rawTextLength } from 'helpers/String';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import trim from 'lodash/trim';

export const CONDITIONS_PROPS = {
  ALLOW_TAGS: 'allowTags',
  MIN: 'min',
  MAX_LENGTH: 'maxLength',
  MAX_RAW_LENGTH: 'maxRawLength',
  MIN_LENGTH: 'minLength',
  REQUIRED: 'required',
  VALIDATE: 'validate'
};

function checkRequiredField(value, conditions) {
  const emptyWithTags = isNil(value) || isEmpty(trim(value));
  const emptyRemovingTags = emptyWithTags || rawTextLength(value) === 0;

  return conditions.allowTags ? emptyWithTags : emptyRemovingTags;
}

function checkConditionProps(key, value, conditions) {
  switch (key) {
    case CONDITIONS_PROPS.MIN:
      return Currency.currencyStringToNumber(value) < conditions[key];
    case CONDITIONS_PROPS.MAX_LENGTH:
      return value.length > parseInt(conditions[key]);
    case CONDITIONS_PROPS.MAX_RAW_LENGTH:
      return rawTextLength(value) > parseInt(conditions[key]);
    case CONDITIONS_PROPS.MIN_LENGTH:
      return value.length < parseInt(conditions[key]);
    default:
      return false;
  }
}

function checkCondition(key, value, conditions) {
  if (key === CONDITIONS_PROPS.REQUIRED) {
    return checkRequiredField(value, conditions);
  } else if (value) {
    return checkConditionProps(key, value, conditions);
  } else {
    return false;
  }
}

export function validate(conditions, value) {
  const errors = {};

  if (conditions.validate !== false) {
    Object.keys(conditions).forEach((key) => {
      const restrictionValue = conditions[key];

      if (key !== CONDITIONS_PROPS.VALIDATE && restrictionValue) {
        errors[key] = checkCondition(key, value, conditions);
      }
    });
  }

  return errors;
}
